export const paths = {
	getTemplate: "guardian/api/v1/digitalStore/public/getTemplate",
	getPublicKey: "guardian/api/v1/digitalStore/public/key",
	getLeadDetails: "guardian/api/v1/digitalStore/public/fetchLeadData",
	createDraftOrder: "guardian/api/v1/digitalStore/public/kycDraftOrder",
	ecafPOIVerification: "/api/v2/image/upload/facematch/v1",
	ecafPOIUpload: "/api/v2/image/upload/image/v1",
	liveVideoSubmission: "/api/video/upload-video",
};
